<template>
  <div id="app">
    <div class="main-content">
      <navigation></navigation>
      <b-container class="mt-5">
        <router-view />
      </b-container>
    </div>
  </div>
</template>

<script>
import navigation from "./../components/navigation";

export default {
  name: "app",
  components: {
    navigation
  }
};
</script>

<style lang="scss"></style>
